import { CheckSquare, MessageCircle } from "react-feather";
import { FlusAccordion2, IconAccordion2, IconAccordion3, SimpleAccordion2, SimpleAccordion3 } from "../../../Constant";

export const ACCORDION_DATA = [
  {
    text: "Click the accordions below to expand/collapse the accordion content. Use the ",
    code: ".accordion",
  },
];

export const ACCORDION_LIST = [
  {
    id: "2",
    icon: true,
    accordionHeaderClass: "bg-light-primary",
    accordionHeading: "What is the use of web design?",
    spanClass: "font-primary",
    bodyText: <div dangerouslySetInnerHTML={{ __html: SimpleAccordion2 }}></div>,
  },
  {
    id: "3",
    icon: true,
    accordionHeaderClass: "bg-light-primary",
    accordionHeading: "What are the elements of web design?",
    spanClass: "font-primary",
    bodyText: <div dangerouslySetInnerHTML={{ __html: SimpleAccordion3 }}></div>,
  },
];

//Flush Accordion
export const FLUS_DATA = [
  {
    text: "Add ",
    code: ".accordion-flush",
  },
  {
    text: " to remove the default",
    code: " background-color",
  },
  {
    text: " , some borders, and some rounded corners to render accordions edge-to-edge with their parent container.",
  },
];

export const FLUS_LIST = [
  {
    id: "2",
    accordionHeaderClass: "bg-light-success",
    accordionHeading: "What is the use of web design?",
    spanClass: "text-success",
    bodyText: <div dangerouslySetInnerHTML={{ __html: FlusAccordion2 }}></div>,
  },
  {
    id: "3",
    accordionHeaderClass: "bg-light-success",
    accordionHeading: "What are the elements of web design?",
    spanClass: "text-success",
    bodyText: <div dangerouslySetInnerHTML={{ __html: FlusAccordion2 }}></div>,
  },
];

//Multiple Collapse Accordion
export const MULTIPLE_DATA = [
  {
    text: " A   ",
    code: "<button>",
  },
  {
    text: " or",
    code: "<a>",
  },
  {
    text: " can show and hide multiple elements by referencing them with a selector in its href or data-bs-target attribute.",
  },
];

//With Icons Accordion
export const ACCORDION_ICON_DATA = [
  {
    text: "Use the ",
    code: ".accordion ",
  },
  {
    text: "& ",
    code: "feather icons",
  },
  {
    text: " through change look icons accordion.",
  },
];

export const ACCORDION_ICON_LIST = [
  {
    id: "2",
    iconWithTitle: <MessageCircle className="svg-wrapper me-2 text-warning" />,
    icon: true,
    accordionHeaderClass: "gap-2 bg-light-warning txt-warning",
    accordionHeading: "What is the use of web design?",
    spanClass:"text-warning",
    bodyText: <div dangerouslySetInnerHTML={{ __html: IconAccordion2 }}></div>,
  },
  {
    id: "3",
    iconWithTitle: <CheckSquare className="svg-wrapper me-2 text-warning" />,
    icon: true,
    accordionHeaderClass: "gap-2 bg-light-warning txt-warning",
    accordionHeading: "What are the elements of web design?",
    spanClass:"text-warning",
    bodyText: <div dangerouslySetInnerHTML={{ __html: IconAccordion3 }}></div>,
  },
];

//Outline Accordions
export const OUTLINE_DATA = [
  {
    text: "make custom ",
    code: ".accordion-wrapper",
  },
  {
    text: " class use to bring border-left side.",
  },
];

export const OUTLINE_LIST = [
  {
    id: "2",
    icon: true,
    accordionItemClass: "accordion-wrapper",
    accordionHeaderClass: "bg-light-primary",
    accordionHeading: "What is the use of web design?",
    spanClass: "font-primary",
    bodyText: <div dangerouslySetInnerHTML={{ __html: SimpleAccordion2 }}></div>,
  },
  {
    id: "3",
    icon: true,
    accordionItemClass: "accordion-wrapper",
    accordionHeaderClass: "bg-light-primary",
    accordionHeading: "What are the elements of web design?",
    spanClass: "font-primary",
    bodyText: <div dangerouslySetInnerHTML={{ __html: SimpleAccordion3 }}></div>,
  },
];

//Horizontal Accordion
export const ACCORDION_HORIZONTAL = [
  {
    text: "Add the ",
    code: ".collapse-horizontal",
  },
  {
    text: " modifier class to transition the width instead of height and set a width on the immediate child element.",
  },
];

//Collapse Accordions
export const ACCORDION_COLLAPSE = [
  {
    text: "you can also use a link with the href attribute",
    code: "(and a role='button').",
  },
  {
    text: "In both cases, the ",
    code: "data-bs-toggle='collapse'",
  },
  {
    text: "is required.",
  },
];
